import { on } from 'delegated-events'

const SELECTORS = Selectors({
  root: 'usergroup-selector',
  toggleButton: 'usergroup-selector button'
})

const $userGroupSelectors = document.querySelectorAll(SELECTORS.asClass('root'))

const fn = {
  init: () => {
    fn.bindEvents()
  },

  bindEvents: () => {
    on('click', SELECTORS.asClass('toggleButton'), function () {
      const $selector = this.closest(SELECTORS.asClass('root'))

      $selector.classList.toggle('is-active')
      this.setAttribute('aria-expanded', this.getAttribute('aria-expanded') === 'false')

      $($selector).find('ul').slideToggle('fast')
    })

    document.body.addEventListener('click', e => {
      if (!e.target.closest(SELECTORS.asClass('root'))) {
        fn.closeAll()
      }
    })
  },

  closeAll: () => {
    $userGroupSelectors.forEach($el => {
      $el.classList.remove('is-active')
      $el.querySelector('button').setAttribute('aria-expanded', false)

      $($el).find('ul').slideUp('fast')
    })
  }
}

export default {
  can: () => $userGroupSelectors.length,
  run: fn.init
}
